function _mime(option, value) {
    var mimeTypes = navigator.mimeTypes;
    for (var mt in mimeTypes) {
        if (mimeTypes[mt][option] == value) {
            return true;
        }
    }
    return false;
}

export default {
    setUser(data) {
        sessionStorage.setItem('user', JSON.stringify(data))
    },
    getUser() {
        let s = sessionStorage.getItem('user') || '{}'
        return JSON.parse(s)
    },
    isPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"
        ];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    },
    initRem(pageWidth) {
        let width = pageWidth || 320
        /* 这里我们利用了一个自执行函数 */
        function change() {
            /* 这里的html字体大小利用了一个简单书序公式（十字相乘），当我们默认设置以屏幕320px位基准此时的字体大小为20px(320    20px),那么浏览器窗口大小改变的时候新的html的fontSize（clientWidth  新的值）就是clientWidth*20/320 */
            document.documentElement.style.fontSize =
                (document.documentElement.clientWidth * 100) / width + "px";
        }
        /* 监听窗口大小发生改变时 */
        window.addEventListener("resize", change, false);
        change();
    },
    //判断浏览器
    checkBrowser() {
        var ua = navigator.userAgent.toLocaleLowerCase();
        var browserType = null;
        if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
            browserType = "IE";
        } else if (ua.match(/firefox/) != null) {
            browserType = "火狐";
        } else if (ua.match(/ubrowser/) != null) {
            browserType = "UC";
        } else if (ua.match(/opera/) != null) {
            browserType = "欧朋";
        } else if (ua.match(/bidubrowser/) != null) {
            browserType = "百度";
        } else if (ua.match(/metasr/) != null) {
            browserType = "搜狗";
        } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
            browserType = "QQ";
        } else if (ua.match(/maxthon/) != null) {
            browserType = "遨游";
        } else if (ua.match(/chrome/) != null) {
            var is360 = _mime("type", "application/vnd.chromium.remoting-viewer");

            if (is360) {
                browserType = '360';
            } else {
                browserType = "谷歌";
            }
        } else if (ua.match(/safari/) != null) {
            browserType = "Safari";
        }
        return browserType;
    },
}